import React from 'react';
import 'date-fns';
import { CAR_STATUS } from 'src/app/constant/config';
import { Box, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: '4px 0',
  },
  statusItem: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    gap: '4px',
    padding: '4px 6px',
    borderRadius: '4px',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  statusActive: {
    backgroundColor: 'rgba(217, 4, 47, 0.08)',
    '& $label, & $count': {
      color: '#d9042f',
      fontWeight: '700',
    }
  },
  iconImg: {
    width: '14px',
    height: '14px',
    objectFit: 'contain',
  },
  count: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#0C1132',
  },
  label: {
    fontSize: '12px',
    color: '#666',
    whiteSpace: 'nowrap'
  }
}));

const CarStatusBar = ({ setCarStatus, carStatus }) => {
  const classes = useStyles();

  const statisticVehicleStatus = useSelector(
    state => state.vehicleSlice.statisticVehicleStatus
  );

  const handleSelectCar = car => {
    if (carStatus === car.value) {
      setCarStatus(null);
    } else {
      setCarStatus(car.value);
    }
  };

  const statusCounts = useMemo(() => ({
    moving: statisticVehicleStatus?.moving || 0,
    stopped: statisticVehicleStatus?.stopped || 0,
    over_speed: statisticVehicleStatus?.over_speed || 0,
    lost_gps: statisticVehicleStatus?.lost_gps || 0,
    lost_gms: statisticVehicleStatus?.lost_gms || 0
  }), [statisticVehicleStatus]);

  return (
    <Box className={classes.container}>
      {CAR_STATUS &&
        CAR_STATUS.map((car, index) => (
          <Box
            key={car.value}
            className={`${classes.statusItem} ${carStatus === car.value ? classes.statusActive : ''}`}
            onClick={() => handleSelectCar(car)}
          >
            <Typography className={classes.count}>
              {statusCounts[car.value] || 0}
            </Typography>
            <img
              alt="icon"
              src={`/static/iconSvg/carsv2/${car?.icon}.svg`}
              className={classes.iconImg}
            />
            <Typography className={classes.label}>
              {car?.label}
            </Typography>
          </Box>
        ))}
    </Box>
  );
};

export default CarStatusBar;
